export default __webpack_public_path__ + "static/media/note.19800672.svg";